import { EventCallback } from '@otto-ec/global-resources/event-q-bus';

export interface ProductTracking {
    /**
     * passed from ui-aggregator from detailview. TODO remove after detailview is removed
     */
    eventMergeId?: string;
}

export interface ProductState {
    /**
     * keeps state if variation is changed by dimension selection or not
     */
    isVariationChanged?: boolean;
}

export interface ProductData {
    /**
     * entered articleNumberAndPromotion from article number search
     */
    enteredArticleNumberAndPromotion?: string;
}

export interface GlobalOProduct {
    /**
     * tracking state
     * probably will be unused after detailview is removed
     */
    tracking: ProductTracking;

    state: ProductState;

    data: ProductData;
    reloadCallbacks: EventCallback[];
    debug: boolean;
}

declare global {
    // eslint-disable-next-line no-var
    var o_product: GlobalOProduct;
}

export function initializeOProduct() {
    if (!window.o_product) {
        window.o_product = {
            tracking: {},
            state: {},
            data: {},
            reloadCallbacks: [],
            debug: false,
        };
    }
    if (!window.o_product.tracking) {
        window.o_product.tracking = {};
    }

    if (!window.o_product.state) {
        window.o_product.state = { isVariationChanged: false };
    }

    if (!window.o_product.data) {
        window.o_product.data = {};
    }
    if (!window.o_product.reloadCallbacks) {
        window.o_product.reloadCallbacks = [];
    }
}
